<div class="spinner-wrapper" [ngClass]="loaderHeight">
  <img src="{{loader}}" alt="IPOSPAYS LOADER" width="120" height="120" />
</div>